import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { EditorData } from "../../state/BookingCreateManagerV2/EditorData";

const updateBookingCreateManagerV2EditorData: Reducer<EditorData> = (state: EditorData = new EditorData(), action: Action<ActionType, EditorData>) => {
  switch (action.type) {
    case ActionType.BOOKING_CREATE_MANAGER_V2_EDITOR_DATA_RESET:
      return new EditorData();
    case ActionType.BOOKING_CREATE_MANAGER_V2_EDITOR_DATA_FETCHED:
      return { ...state, bookingCreateManagerEditorData: action.data };
    case ActionType.BOOKING_CREATE_MANAGER_V2_EDITOR_DATA_COPIED:
      return { ...state, bookingCreateManagerEditorData: { ...action.data} };
    case ActionType.BOOKING_CREATE_MANAGER_V2_EDITOR_DATA_UPDATED:
      return { ...state, bookingCreateManagerEditorData: { ...state.bookingCreateManagerEditorData, ...action.data } };
    case ActionType.BOOKING_CREATE_MANAGER_V2_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.BOOKING_CREATE_MANAGER_V2_EDITOR_DATA_VALIDATED:
      return { ...state, validation: {...action.data }};
    case ActionType.BOOKING_CREATE_MANAGER_V2_EDITOR_SET_BOUND_ITEM:
      return {...state, bookingCreateManagerEditorData: {...state.bookingCreateManagerEditorData, ...action.data}}
    default:
      return state;
  }
};

export default updateBookingCreateManagerV2EditorData;
